import type { ConfigName } from './names';

export interface ConfigHostsEntry {
    hideInListing: boolean;
    hosts: string[];
    idFirma: number;
}

export const mapHosts: Record<ConfigName, ConfigHostsEntry> = {
    'Local Fleet Server': {
        hosts: ['localhost'],
        idFirma: 9800,
        hideInListing: true,
    },
    'BDK BETA': {
        hosts: [
            'bdk-dev.autohaus-digital.de',
            'bdk-live.autohaus-digital.de',
            'bdk-next.autohaus-digital.de',
            'bdk-pre-release.autohaus-digital.de',
            'bdk-test.autohaus-digital.de',
            'bdk-beta.autohaus-digital.de',
        ],
        idFirma: 54612,
        hideInListing: false,
    },
    ACC: {
        hosts: ['acc-dev.autohaus-digital.de', 'acc-live.autohaus-digital.de', 'acc-next.autohaus-digital.de', 'acc-pre-release.autohaus-digital.de', 'acc-test.autohaus-digital.de', 'autocarl.de'],
        idFirma: 30159,
        hideInListing: false,
    },
    Albertsmeyer: {
        hosts: [
            'albertsmeyer-dev.autohaus-digital.de',
            'albertsmeyer-live.autohaus-digital.de',
            'albertsmeyer-pre-release.autohaus-digital.de',
            'albertsmeyer-test.autohaus-digital.de',
            'albertsmeyer-next.autohaus-digital.de',
        ],
        idFirma: 52400,
        hideInListing: false,
    },
    AMB: { hosts: ['amb-autowelt.de'], idFirma: 12290, hideInListing: false },
    'ASS Senftenberg': {
        hosts: [
            'ass-dev.autohaus-digital.de',
            'ass-live.autohaus-digital.de',
            'ass-pre-release.autohaus-digital.de',
            'ass-test.autohaus-digital.de',
            'ass-next.autohaus-digital.de',
            'ass-senftenberg.de',
        ],
        idFirma: 36189,
        hideInListing: false,
    },
    'Auto Diehl': {
        hosts: ['diehl-dev.autohaus-digital.de', 'diehl-live.autohaus-digital.de', 'diehl-pre-release.autohaus-digital.de', 'diehl-test.autohaus-digital.de', 'diehl-next.autohaus-digital.de'],
        idFirma: 30165,
        hideInListing: false,
    },
    'Auto Henke': {
        hosts: [
            'henke-dev.autohaus-digital.de',
            'henke-live.autohaus-digital.de',
            'henke-next.autohaus-digital.de',
            'henke-pre-release.autohaus-digital.de',
            'henke-test.autohaus-digital.de',
            'auto-henke.de',
        ],
        idFirma: 54790,
        hideInListing: false,
    },
    'Autohaus Bauer': { hosts: ['ah-bauer.de'], idFirma: 30150, hideInListing: false },
    'Autohaus-Digital Fleet': {
        hosts: ['fleet-dev.autohaus-digital.de', 'fleet-next.autohaus-digital.de', 'fleet-pre-release.autohaus-digital.de', 'fleet-test.autohaus-digital.de', 'fleet.autohaus-digital.de'],
        idFirma: 9800,
        hideInListing: true,
    },
    'Autohaus-Digital S-R': {
        hosts: [
            'web-dev.autohaus-digital.de',
            'web-next.autohaus-digital.de',
            'web-pre-release.autohaus-digital.de',
            'web-test.autohaus-digital.de',
            'web.autohaus-digital.de',
            'ahd-dev.autohaus-digital.de',
            'ahd-next.autohaus-digital.de',
            'ahd-pre-release.autohaus-digital.de',
            'ahd-test.autohaus-digital.de',
            'ahd-live.autohaus-digital.de',
            'ahddemo-dev.autohaus-digital.de',
            'ahddemo-next.autohaus-digital.de',
            'ahddemo-pre-release.autohaus-digital.de',
            'ahddemo-test.autohaus-digital.de',
            'ahddemo-live.autohaus-digital.de',
            'ahddemo.autohaus-digital.de',
        ],
        idFirma: 9800,
        hideInListing: true,
    },
    'Autocenter Burgenland': {
        hosts: [
            'ac-burgenland-dev.autohaus-digital.de',
            'burgenland.autohaus-digital.de',
            'ac-burgenland-next.autohaus-digital.de',
            'ac-burgenland-pre-release.autohaus-digital.de',
            'ac-burgenland-test.autohaus-digital.de',
        ],
        idFirma: 52960,
        hideInListing: false,
    },
    'Autohaus Baumann': { hosts: ['autohaus-baumann.de'], idFirma: 54320, hideInListing: false },
    'Autohaus Bäumer': {
        hosts: [
            'baeumer-dev.autohaus-digital.de',
            'baeumer-live.autohaus-digital.de',
            'baeumer-next.autohaus-digital.de',
            'baeumer-pre-release.autohaus-digital.de',
            'baeumer-test.autohaus-digital.de',
            'autohaus-baeumer.de',
            'hyundai-baeumer-dev.autohaus-digital.de',
            'hyundai-baeumer-live.autohaus-digital.de',
            'hyundai-baeumer-next.autohaus-digital.de',
            'hyundai-baeumer-pre-release.autohaus-digital.de',
            'hyundai-baeumer-test.autohaus-digital.de',
            'hyundai.autohaus-baeumer.de',
        ],
        idFirma: 54806,
        hideInListing: false,
    },
    'Autohaus Baumhoff': { hosts: ['autohaus-baumhoff.de'], idFirma: 53670, hideInListing: false },
    'Autohaus Cramer-Schmitz': {
        hosts: [
            'cramer-schmitz.de',
            'cramer-schmitz-dev.autohaus-digital.de',
            'cramer-schmitz-live.autohaus-digital.de',
            'cramer-schmitz-next.autohaus-digital.de',
            'cramer-schmitz-pre-release.autohaus-digital.de',
            'cramer-schmitz-test.autohaus-digital.de',
        ],
        idFirma: 54810,
        hideInListing: false,
    },
    'Autohaus Dippoldiswalde': {
        hosts: [
            'autohaus-dippoldiswalde.de',
            'dippoldiswalde-dev.autohaus-digital.de',
            'dippoldiswalde-live.autohaus-digital.de',
            'dippoldiswalde-next.autohaus-digital.de',
            'dippoldiswalde-pre-release.autohaus-digital.de',
            'dippoldiswalde-test.autohaus-digital.de',
        ],
        idFirma: 54130,
        hideInListing: false,
    },
    'Autohaus Eckstein': {
        hosts: [
            'skoda-sonneberg.de',
            'eckstein-dev.autohaus-digital.de',
            'eckstein-live.autohaus-digital.de',
            'eckstein-next.autohaus-digital.de',
            'eckstein-pre-release.autohaus-digital.de',
            'eckstein-test.autohaus-digital.de',
        ],
        idFirma: 54811,
        hideInListing: false,
    },
    'Autohaus Elmshorn': {
        hosts: [
            'autohaus-elmshorn.de',
            'elmshorn-dev.autohaus-digital.de',
            'elmshorn-live.autohaus-digital.de',
            'elmshorn-next.autohaus-digital.de',
            'elmshorn-pre-release.autohaus-digital.de',
            'elmshorn-test.autohaus-digital.de',
        ],
        idFirma: 30173,
        hideInListing: false,
    },
    'Autohaus Erlenhoff': {
        hosts: [
            'erlenhoff-dev.autohaus-digital.de',
            'erlenhoff-live.autohaus-digital.de',
            'erlenhoff-next.autohaus-digital.de',
            'erlenhoff-pre-release.autohaus-digital.de',
            'erlenhoff-test.autohaus-digital.de',
            'erlenhoff.de',
        ],
        idFirma: 52590,
        hideInListing: false,
    },
    'Autohaus Feicht': { hosts: ['feicht.de'], idFirma: 50860, hideInListing: false },
    'Autohaus Franke': { hosts: ['autohaus-franke.com'], idFirma: 49252, hideInListing: false },
    'Autohaus G. Neumann': { hosts: ['autohaus-neumann.de'], idFirma: 48801, hideInListing: false },
    'Autohaus Häfner': {
        hosts: [
            'af-haefner-dev.autohaus-digital.de',
            'af-haefner-live.autohaus-digital.de',
            'af-haefner-next.autohaus-digital.de',
            'af-haefner-pre-release.autohaus-digital.de',
            'af-haefner-test.autohaus-digital.de',
            'autoforum-haefner.de',
        ],
        idFirma: 54807,
        hideInListing: false,
    },
    'Autohaus Hannuschka': {
        hosts: [
            'hannuschka-dev.autohaus-digital.de',
            'hannuschka-live.autohaus-digital.de',
            'hannuschka-next.autohaus-digital.de',
            'hannuschka-pre-release.autohaus-digital.de',
            'hannuschka-test.autohaus-digital.de',
            'opel-hannuschka.de',
        ],
        idFirma: 54794,
        hideInListing: false,
    },
    'Autohaus Hoch': { hosts: ['autohaus-hoch.de'], idFirma: 53420, hideInListing: false },
    'Autohaus Hoppe': { hosts: ['autohaus-hoppe.com'], idFirma: 53910, hideInListing: false },
    'Autohaus Hoppe - Test Domain': { hosts: ['em26171.vautron05.eventomaxx.de'], idFirma: 53910, hideInListing: false },
    'Autohaus Ihle': {
        hosts: [
            'ihle-nortorf-dev.autohaus-digital.de',
            'ihle-nortorf-live.autohaus-digital.de',
            'ihle-nortorf-next.autohaus-digital.de',
            'ihle-nortorf-pre-release.autohaus-digital.de',
            'ihle-nortorf-test.autohaus-digital.de',
        ],
        idFirma: 51410,
        hideInListing: false,
    },
    'Autohaus Josef Geers': { hosts: ['autohaus-geers.de'], idFirma: 54565, hideInListing: false },
    'Autohaus Kießling': { hosts: [
        'kiessling-zwickau.de',
    ], idFirma: 36883, hideInListing: false },
    'Autohaus Kießling WEB': { hosts: [
        'kiessling-zwickau-dev.autohaus-digital.de',
        'kiessling-zwickau-live.autohaus-digital.de',
        'kiessling-zwickau-next.autohaus-digital.de',
        'kiessling-zwickau-pre-release.autohaus-digital.de',
        'kiessling-zwickau-test.autohaus-digital.de',
        'kiessling-zwickau.autohaus-digital.de',
    ], idFirma: 36883, hideInListing: false },
    'Autohaus Koch': { hosts: ['autohauskoch.com'], idFirma: 53920, hideInListing: false },
    'Autohaus Küver': { hosts: ['kuever.com', 'autohaus-kuver.onepage.me'], idFirma: 54793, hideInListing: false },
    'Autohaus Kuhn+Witte': { hosts: ['autohaus.kuhn-witte.de'], idFirma: 30156, hideInListing: false },
    'Autohaus Lamminger': {
        hosts: [
            'lamminger-dev.autohaus-digital.de',
            'lamminger-live.autohaus-digital.de',
            'lamminger-next.autohaus-digital.de',
            'lamminger-pre-release.autohaus-digital.de',
            'lamminger-test.autohaus-digital.de',
            'autohaus-lamminger.de',
        ],
        idFirma: 53890,
        hideInListing: false,
    },
    'Autohaus Lich': {
        hosts: [
            'lich-dev.autohaus-digital.de',
            'lich-live.autohaus-digital.de',
            'lich-next.autohaus-digital.de',
            'lich-pre-release.autohaus-digital.de',
            'lich-test.autohaus-digital.de',
            'autohaus-lich.de',
        ],
        idFirma: 54600,
        hideInListing: false,
    },
    'Autohaus Lucks': {
        hosts: ['autohaus-lucks.de', 'lucks.wieprich-werbung.de'],
        idFirma: 51420,
        hideInListing: false,
    },
    'Autohaus an der Lutherkirche': {
        hosts: [
            'ahl-dev.autohaus-digital.de',
            'ahl-live.autohaus-digital.de',
            'ahl-next.autohaus-digital.de',
            'ahl-pre-release.autohaus-digital.de',
            'ahl-test.autohaus-digital.de',
            'ahl-chemnitz.de',
        ],
        idFirma: 48123,
        hideInListing: false,
    },
    'Autohaus Manz': { hosts: ['autohaus-manz.de'], idFirma: 11910, hideInListing: false },
    'Autohaus Meinhold': { hosts: ['autohaus-meinhold.de'], idFirma: 11970, hideInListing: false },
    'Autohaus Niggemeier': { hosts: ['niggemeier.de'], idFirma: 54778, hideInListing: false },
    'Autohaus Nord': {
        hosts: [
            'guestrow-dev.autohaus-digital.de',
            'guestrow-live.autohaus-digital.de',
            'guestrow-next.autohaus-digital.de',
            'guestrow-pre-release.autohaus-digital.de',
            'guestrow-test.autohaus-digital.de',
            'auto-guestrow.de',
        ],
        idFirma: 30178,
        hideInListing: false,
    },
    'Autohaus Perski': { hosts: ['autohaus-perski.de'], idFirma: 10190, hideInListing: false },
    'Autohaus Pietsch': {
        hosts: [
            'pietsch-dev.autohaus-digital.de',
            'pietsch-live.autohaus-digital.de',
            'pietsch-next.autohaus-digital.de',
            'pietsch-pre-release.autohaus-digital.de',
            'pietsch-test.autohaus-digital.de',
            'autohaus-pietsch.de',
        ],
        idFirma: 54809,
        hideInListing: false,
    },
    'Autohaus Rabus': { hosts: ['autohaus-rabus.de', 'autohaus-rabus.papillo.fun'], idFirma: 54789, hideInListing: false },
    'Autohaus Range': { hosts: ['autohaus-range.de'], idFirma: 54360, hideInListing: false },
    'Autohaus Rudolph': { hosts: ['seat-rudolph.com', 'vw-rudolph.com'], idFirma: 30150, hideInListing: false },
    'Autohaus Schäfer': {
        hosts: [
            'schaefer-mon-dev.autohaus-digital.de',
            'schaefer-mon-live.autohaus-digital.de',
            'schaefer-mon-next.autohaus-digital.de',
            'schaefer-mon-pre-release.autohaus-digital.de',
            'schaefer-mon-test.autohaus-digital.de',
            'automobile-schaefer.de',
        ],
        idFirma: 54808,
        hideInListing: false,
    },
    'Autohaus Schäfer Hyundai': {
        hosts: [
            'hyundai-schaefer-mon-dev.autohaus-digital.de',
            'hyundai-schaefer-mon-live.autohaus-digital.de',
            'hyundai-schaefer-mon-next.autohaus-digital.de',
            'hyundai-schaefer-mon-pre-release.autohaus-digital.de',
            'hyundai-schaefer-mon-test.autohaus-digital.de',
            'hyundai.automobile-schaefer.de',
        ],
        idFirma: 54808,
        hideInListing: false,
    },
    'Autohaus Schäfer Mazda': {
        hosts: [
            'mazda-schaefer-mon-dev.autohaus-digital.de',
            'mazda-schaefer-mon-live.autohaus-digital.de',
            'mazda-schaefer-mon-next.autohaus-digital.de',
            'mazda-schaefer-mon-pre-release.autohaus-digital.de',
            'mazda-schaefer-mon-test.autohaus-digital.de',
            'mazda.automobile-schaefer.de',
        ],
        idFirma: 54808,
        hideInListing: false,
    },
    'Autohaus Schäfer Nissan': {
        hosts: [
            'nissan-schaefer-mon-dev.autohaus-digital.de',
            'nissan-schaefer-mon-live.autohaus-digital.de',
            'nissan-schaefer-mon-next.autohaus-digital.de',
            'nissan-schaefer-mon-pre-release.autohaus-digital.de',
            'nissan-schaefer-mon-test.autohaus-digital.de',
            'nissan.automobile-schaefer.de',
        ],
        idFirma: 54808,
        hideInListing: false,
    },
    'Autohaus Schenkel': {
        hosts: [
            'schenkel-dev.autohaus-digital.de',
            'schenkel-live.autohaus-digital.de',
            'schenkel-next.autohaus-digital.de',
            'schenkel-pre-release.autohaus-digital.de',
            'schenkel-test.autohaus-digital.de',
            'autohaus-schenkel.de',
        ],
        idFirma: 54615,
        hideInListing: false,
    },
    'Autohaus Seifert': { hosts: ['vw-seifert.de'], idFirma: 30150, hideInListing: false },
    'Autohaus Schulz & Straube S-R': {
        hosts: [
            'schulz-straube-dev.autohaus-digital.de',
            'schulz-straube-live.autohaus-digital.de',
            'schulz-straube-next.autohaus-digital.de',
            'schulz-straube-pre-release.autohaus-digital.de',
            'schulz-straube-test.autohaus-digital.de',
            'schulz-straube.autohaus-digital.de',
        ],
        idFirma: 48921,
        hideInListing: false,
    },
    'Autohaus Schulz & Straube': { hosts: ['schulz-straube.de'], idFirma: 48921, hideInListing: false },
    'Autohaus Spranger': { hosts: ['autohaus-spranger.de'], idFirma: 10210, hideInListing: false },
    'Autohaus Steinhoff': {
        hosts: ['autohaus-steinhoff.de', 'steinhoff-live.autohaus-digital.de', 'steinhoff-next.autohaus-digital.de', 'steinhoff-dev.autohaus-digital.de'],
        idFirma: 54782,
        hideInListing: false,
    },
    'Autohaus Hoppmann & Schneider': { hosts: ['hoppmann-schneider.de'], idFirma: 54785, hideInListing: false },
    'Autohaus Vollmer': { hosts: ['autohaus-vollmer.de'], idFirma: 11440, hideInListing: false },
    'Autohaus Weber': { hosts: ['autos-weber.de', 'autos-weber.com'], idFirma: 49612, hideInListing: false },
    'Autohaus Winter': { hosts: ['ah-winter.de'], idFirma: 53810, hideInListing: false },
    'Autohaus Wittenberg': { hosts: ['ah-wittenberg.de'], idFirma: 11980, hideInListing: false },
    'Automobile Werner': { hosts: ['automobile-werner.de'], idFirma: 12040, hideInListing: false },
    autonext: {
        hosts: [
            'autonext-dev.autohaus-digital.de',
            'autonext-live.autohaus-digital.de',
            'autonext-next.autohaus-digital.de',
            'autonext-pre-release.autohaus-digital.de',
            'autonext-test.autohaus-digital.de',
            'auto-next.de',
        ],
        idFirma: 54805,
        hideInListing: false,
    },
    'Autopark Dippel': { hosts: ['autopark-dippel.de'], idFirma: 53040, hideInListing: false },
    'Autowelt Schuler': { hosts: ['autowelt-schuler.de'], idFirma: 30046, hideInListing: false },
    'Autozentrale Sturm': {
        hosts: [
            'autozentrale-sturm-dev.autohaus-digital.de',
            'autozentrale-sturm-live.autohaus-digital.de',
            'autozentrale-sturm-next.autohaus-digital.de',
            'autozentrale-sturm-pre-release.autohaus-digital.de',
            'autozentrale-sturm-test.autohaus-digital.de',
            'autozentrale-sturm.de',
        ],
        idFirma: 54040,
        hideInListing: false,
    },
    'Autozentrum Frankenthal': { hosts: ['autozentrum-frankenthal.de'], idFirma: 54599, hideInListing: false },
    'Auto Brass': { hosts: ['auto-brass.com'], idFirma: 54440, hideInListing: false },
    'Auto Hofmann': { hosts: ['auto-hofmann.de'], idFirma: 30169, hideInListing: false },
    'Auto Meyer': {
        hosts: [
            'automeyer-ochsenfurt.de',
            'automeyer-dev.autohaus-digital.de',
            'automeyer-live.autohaus-digital.de',
            'automeyer-next.autohaus-digital.de',
            'automeyer-pre-release.autohaus-digital.de',
            'automeyer-test.autohaus-digital.de',
        ],
        idFirma: 53770,
        hideInListing: false,
    },
    'Auto Müller': { hosts: ['auto-mueller-online.de'], idFirma: 54100, hideInListing: false },
    'Auto Zeilinger': {
        hosts: [
            'zeilinger-dev.autohaus-digital.de',
            'zeilinger-live.autohaus-digital.de',
            'zeilinger-next.autohaus-digital.de',
            'zeilinger-pre-release.autohaus-digital.de',
            'zeilinger-test.autohaus-digital.de',
            'auto-zeilinger.de',
        ],
        idFirma: 54625,
        hideInListing: false,
    },
    'AV Beier': { hosts: ['avbeier.de'], idFirma: 53850, hideInListing: false },
    'AVEMO Fleet': { hosts: ['avemo-fleet.de'], idFirma: 30179, hideInListing: false },
    'AVEMO Gruppe': { hosts: ['avemo-group.de'], idFirma: 30179, hideInListing: false },
    'AZF Gruppe': { hosts: ['azf-gruppe.de'], idFirma: 54781, hideInListing: false },
    BaderMainzl: { hosts: ['badermainzl.de', 'innsiders-projekte.de'], idFirma: 54610, hideInListing: false },
    Best: { hosts: ['my-mobility.group'], idFirma: 30180, hideInListing: false },
    'Best S-R': {
        hosts: [
            'best-familie-dev.autohaus-digital.de',
            'best-familie-live.autohaus-digital.de',
            'best-familie-next.autohaus-digital.de',
            'best-familie-pre-release.autohaus-digital.de',
            'best-familie-test.autohaus-digital.de',
            'autohaus-best.de',
        ],
        idFirma: 30180,
        hideInListing: false,
    },
    'Block am Ring': { hosts: ['blockamring.net'], idFirma: 30167, hideInListing: false },
    Boxhammer: { hosts: ['boxhammer.de'], idFirma: 51460, hideInListing: false },
    'Caravan Center Nord': {
        hosts: [
            'ccn-dev.autohaus-digital.de',
            'ccn-live.autohaus-digital.de',
            'ccn-next.autohaus-digital.de',
            'ccn-pre-release.autohaus-digital.de',
            'ccn-test.autohaus-digital.de',
            'caravan-center-nord.de',
        ],
        idFirma: 54787,
        hideInListing: false,
    },
    'Clever-Driver-Wetzlar': { hosts: ['clever-driver-wetzlar.de', 'www-clever-driver-wetzlar-de.filesusr.com'], idFirma: 54100, hideInListing: false },
    Dabag: { hosts: ['dabag.de'], idFirma: 30174, hideInListing: false },
    'Dein Autozentrum Woldegk': {
        hosts: [
            'woldegk-dev.autohaus-digital.de',
            'woldegk-live.autohaus-digital.de',
            'woldegk-next.autohaus-digital.de',
            'woldegk-pre-release.autohaus-digital.de',
            'woldegk-test.autohaus-digital.de',
            'dein-gebrauchtwagen-zentrum.de',
        ],
        idFirma: 30175,
        hideInListing: false,
    },
    'Die Autohaus Gruppe S-R': {
        hosts: [
            'die-autohaus-gruppe-dev.autohaus-digital.de',
            'die-autohaus-gruppe-live.autohaus-digital.de',
            'die-autohaus-gruppe-next.autohaus-digital.de',
            'die-autohaus-gruppe-pre-release.autohaus-digital.de',
            'die-autohaus-gruppe-test.autohaus-digital.de',
            'die-autohaus-gruppe.de',
            'wernigerode-dev.autohaus-digital.de',
            'wernigerode-live.autohaus-digital.de',
            'wernigerode-next.autohaus-digital.de',
            'wernigerode-pre-release.autohaus-digital.de',
            'wernigerode-test.autohaus-digital.de',
            'wernigerode.die-autohaus-gruppe.de',
            'autohaus-am-regenstein-dev.autohaus-digital.de',
            'autohaus-am-regenstein-live.autohaus-digital.de',
            'autohaus-am-regenstein-next.autohaus-digital.de',
            'autohaus-am-regenstein-pre-release.autohaus-digital.de',
            'autohaus-am-regenstein-test.autohaus-digital.de',
            'regenstein.die-autohaus-gruppe.de',
            'halbac-dev.autohaus-digital.de',
            'halbac-live.autohaus-digital.de',
            'halbac-next.autohaus-digital.de',
            'halbac-pre-release.autohaus-digital.de',
            'halbac-test.autohaus-digital.de',
            'halbac.die-autohaus-gruppe.de',
            'quedac-dev.autohaus-digital.de',
            'quedac-live.autohaus-digital.de',
            'quedac-next.autohaus-digital.de',
            'quedac-pre-release.autohaus-digital.de',
            'quedac-test.autohaus-digital.de',
            'quedac.die-autohaus-gruppe.de',
            'Osterwieck-dev.autohaus-digital.de',
            'Osterwieck-live.autohaus-digital.de',
            'Osterwieck-next.autohaus-digital.de',
            'Osterwieck-pre-release.autohaus-digital.de',
            'Osterwieck-test.autohaus-digital.de',
            'osterwieck.die-autohaus-gruppe.de',
            'bergmann-dev.autohaus-digital.de',
            'bergmann-live.autohaus-digital.de',
            'bergmann-next.autohaus-digital.de',
            'bergmann-pre-release.autohaus-digital.de',
            'bergmann-test.autohaus-digital.de',
            'bergmann.die-autohaus-gruppe.de',
            'lcw-dev.autohaus-digital.de',
            'lcw-live.autohaus-digital.de',
            'lcw-next.autohaus-digital.de',
            'lcw-pre-release.autohaus-digital.de',
            'lcw-test.autohaus-digital.de',
            'lcw-wernigerode.die-autohaus-gruppe.de',
            'nora-osterwieck-dev.autohaus-digital.de',
            'nora-osterwieck-live.autohaus-digital.de',
            'nora-osterwieck-next.autohaus-digital.de',
            'nora-osterwieck-pre-release.autohaus-digital.de',
            'nora-osterwieck-test.autohaus-digital.de',
            'nora-zentrum-osterwieck.die-autohaus-gruppe.de',
        ],
        idFirma: 30008,
        hideInListing: false,
    },
    'Eichsfelder Autohaus': {
        hosts: [
            'eichsfelder-dev.autohaus-digital.de',
            'eichsfelder-live.autohaus-digital.de',
            'eichsfelder-next.autohaus-digital.de',
            'eichsfelder-pre-release.autohaus-digital.de',
            'eichsfelder-test.autohaus-digital.de',
            'eichsfelder-autohaus.de',
        ],
        idFirma: 54170,
        hideInListing: false,
    },
    Elbtor: { hosts: ['elbtor.de'], idFirma: 54150, hideInListing: false },
    Feddersen: { hosts: ['feddersen-automobile.de'], idFirma: 21700, hideInListing: false },
    Fink: {
        hosts: [
            'fink-dev.autohaus-digital.de',
            'fink-live.autohaus-digital.de',
            'fink-next.autohaus-digital.de',
            'fink-pre-release.autohaus-digital.de',
            'fink-test.autohaus-digital.de',
            'audi-fink.de',
        ],
        idFirma: 54623,
        hideInListing: false,
    },
    'FSN Autohaus': { hosts: ['fsn-autohaus.de', 'fsn-autozentrum.de'], idFirma: 30168, hideInListing: false },
    'Gebr Conrad': { hosts: ['gebr-conrad.de'], idFirma: 48731, hideInListing: false },
    'Glöckner Automobile': { hosts: ['gloeckner-automobile.de'], idFirma: 30170, hideInListing: false },
    Grampp: {
        hosts: [
            'grampp-dev.autohaus-digital.de',
            'grampp-live.autohaus-digital.de',
            'grampp-next.autohaus-digital.de',
            'grampp-pre-release.autohaus-digital.de',
            'grampp-test.autohaus-digital.de',
            'grampp.net',
        ],
        idFirma: 51530,
        hideInListing: false,
    },
    'Gröditzer Autohaus': { hosts: ['groeditzer-autohaus.de'], idFirma: 13540, hideInListing: false },
    'Hager und Penzel': {
        hosts: [
            'hager-penzel-dev.autohaus-digital.de',
            'hager-penzel-live.autohaus-digital.de',
            'hager-penzel-next.autohaus-digital.de',
            'hager-penzel-pre-release.autohaus-digital.de',
            'hager-penzel-test.autohaus-digital.de',
            'hager-und-penzel.de',
        ],
        idFirma: 54795,
        hideInListing: false,
    },
    'Henke Automobile - SEAT Wedel': { hosts: ['seat-wedel.de'], idFirma: 30156, hideInListing: false },
    Hoppmann: { hosts: ['hoppmann-autowelt.de', 'fahrzeugmarkt.hoppmann-autowelt.de'], idFirma: 54612, hideInListing: false },
    Kaesmann: {
        hosts: [
            'kaesmann-dev.autohaus-digital.de',
            'kaesmann-live.autohaus-digital.de',
            'kaesmann-next.autohaus-digital.de',
            'kaesmann-pre-release.autohaus-digital.de',
            'kaesmann-test.autohaus-digital.de',
            'kaesmann.de',
        ],
        idFirma: 54622,
        hideInListing: false,
    },
    'KFZ Rothmund': {
        hosts: [
            'rothmund-dev.autohaus-digital.de',
            'rothmund-live.autohaus-digital.de',
            'rothmund-next.autohaus-digital.de',
            'rothmund-pre-release.autohaus-digital.de',
            'rothmund-test.autohaus-digital.de',
            'kfz-rothmund.de',
        ],
        idFirma: 54804,
        hideInListing: false,
    },
    'Kuenzig Bleuel': {
        hosts: [
            'k-b-dev.autohaus-digital.de',
            'k-b-live.autohaus-digital.de',
            'k-b-next.autohaus-digital.de',
            'k-b-pre-release.autohaus-digital.de',
            'k-b-test.autohaus-digital.de',
            'kuenzig-bleuel.de',
        ],
        idFirma: 54624,
        hideInListing: false,
    },
    'Kuenzig Bleuel Hyundai': {
        hosts: [
            'k-b-h-dev.autohaus-digital.de',
            'k-b-h-live.autohaus-digital.de',
            'k-b-h-next.autohaus-digital.de',
            'k-b-h-pre-release.autohaus-digital.de',
            'k-b-h-test.autohaus-digital.de',
            'hyundai.kuenzig-bleuel.de',
        ],
        idFirma: 54624,
        hideInListing: false,
    },
    'Leo Belting': { hosts: ['leo-belting.de'], idFirma: 46950, hideInListing: false },
    Liliensiek: {
        hosts: [
            'liliensiek.de',
            'liliensiek-dev.autohaus-digital.de',
            'liliensiek-live.autohaus-digital.de',
            'liliensiek-next.autohaus-digital.de',
            'liliensiek-pre-release.autohaus-digital.de',
            'liliensiek-test.autohaus-digital.de',
        ],
        idFirma: 13890,
        hideInListing: false,
    },
    Marnet: { hosts: ['marnet.de'], idFirma: 54619, hideInListing: false },
    Nullaufhundert: {
        hosts: ['nullaufhundert-gruppe.de', 'beta.vw-rudolph.com'],
        idFirma: 30150,
        hideInListing: false,
    },
    'Otto Grimm': {
        hosts: [
            'otto-grimm-dev.autohaus-digital.de',
            'otto-grimm-next.autohaus-digital.de',
            'otto-grimm-pre-release.autohaus-digital.de',
            'otto-grimm-test.autohaus-digital.de',
            'otto-grimm.autohaus-digital.de',
        ],
        idFirma: 30009,
        hideInListing: false,
    },
    OutletCars: {
        hosts: [
            'outletcars-dev.autohaus-digital.de',
            'outletcars-live.autohaus-digital.de',
            'outletcars-next.autohaus-digital.de',
            'outletcars-pre-release.autohaus-digital.de',
            'outletcars-test.autohaus-digital.de',
            'outletcars.de',
        ],
        idFirma: 54630,
        hideInListing: false,
    },
    'Reim Automobile': {
        hosts: [
            'reim-automobile.de',
            'reim-dev.autohaus-digital.de',
            'reim-live.autohaus-digital.de',
            'reim-next.autohaus-digital.de',
            'reim-pre-release.autohaus-digital.de',
            'reim-test.autohaus-digital.de',
        ],
        idFirma: 54090,
        hideInListing: false,
    },
    'Rolf Moser': {
        hosts: [
            'moser-autohaus.de',
            'moser-dev.autohaus-digital.de',
            'moser-live.autohaus-digital.de',
            'moser-next.autohaus-digital.de',
            'moser-pre-release.autohaus-digital.de',
            'moser-test.autohaus-digital.de',
        ],
        idFirma: 54802,
        hideInListing: false,
    },
    'Schäfer Automobile': { hosts: ['schaeferautomobile.de'], idFirma: 54330, hideInListing: false },
    'Schmeink-Gruppe-DEV': { hosts: ['asw.hinsken-advertising.de'], idFirma: 54632, hideInListing: false },
    'Schmeink-Gruppe': { hosts: ['schmeink-gruppe.de'], idFirma: 54632, hideInListing: false },
    Spindler: {
        hosts: [
            'autohaus-rennsteig.de',
            'rennsteig-dev.autohaus-digital.de',
            'rennsteig-live.autohaus-digital.de',
            'rennsteig-next.autohaus-digital.de',
            'rennsteig-pre-release.autohaus-digital.de',
            'rennsteig-test.autohaus-digital.de',
            'spindler-gruppe.de',
            'spindler-dev.autohaus-digital.de',
            'spindler-live.autohaus-digital.de',
            'spindler-next.autohaus-digital.de',
            'spindler-pre-release.autohaus-digital.de',
            'spindler-test.autohaus-digital.de',
            'spindler-gruppe-dev.autohaus-digital.de',
            'spindler-gruppe.autohaus-digital.de',
            'spindler-gruppe-next.autohaus-digital.de',
            'spindler-gruppe-pre-release.autohaus-digital.de',
            'spindler-gruppe-test.autohaus-digital.de',
            'spindler-classics.de',
            'spindler-classix-dev.autohaus-digital.de',
            'spindler-classix-live.autohaus-digital.de',
            'spindler-classix-next.autohaus-digital.de',
            'spindler-classix-pre-release.autohaus-digital.de',
            'spindler-classix-test.autohaus-digital.de',
        ],
        idFirma: 54390,
        hideInListing: false,
    },
    Sportivo: {
        hosts: [
            'sportivo-dev.autohaus-digital.de',
            'sportivo-live.autohaus-digital.de',
            'sportivo-next.autohaus-digital.de',
            'sportivo-pre-release.autohaus-digital.de',
            'sportivo-test.autohaus-digital.de',
            'sportivoleipzig.de',
        ],
        idFirma: 30124,
        hideInListing: false,
    },
    'Thomas Exclusive Cars': { hosts: ['thomas.vollblut-digital.de', 'thomas-exclusive-cars.de'], idFirma: 30181, hideInListing: false },
    'Thomas Exclusive Cars - Aston Martin': { hosts: ['aston-martin.devbite.me', 'astonmartin-dresden.de'], idFirma: 30181, hideInListing: false },
    'Thomas Heavy Metal Bikes': { hosts: ['harley-dresden.com', 'harley-leipzig.com', 'harley-chemnitz.de'], idFirma: 30177, hideInListing: false },
    'Vogt Mobil': { hosts: ['vogt-mobil.de'], idFirma: 54783, hideInListing: false },
    'VW Arnold': { hosts: ['vw-arnold.de'], idFirma: 53180, hideInListing: false },
    'Walter Schneider GmbH & Co KG': { hosts: ['walter-schneider.de'], idFirma: 54613, hideInListing: false },

    // FOR TESTS - DO NOT DELETE!
    Test: { hosts: ['test'], idFirma: 9800, hideInListing: true },
};
